import groupOrderStoreMutations from '@/state/groupOrderStore/groupOrderStoreMutations'
import groupOrderStoreActions from '@/state/groupOrderStore/groupOrderStoreActions'
import getGroupOrderStoreDefaultState from '@/state/groupOrderStore/groupOrderStoreDefaultState'

let state = getGroupOrderStoreDefaultState()

export const groupOrderStore = {
  namespaced: true,
  state,
  mutations: groupOrderStoreMutations,
  actions: groupOrderStoreActions,
  getters: {
    orderAutoFinalizing(state) {
      const orderIsFinalizing =
        state.groupOrderDetails.state !== 'pending' &&
        state.groupOrderDetails.state !== 'auto_finalising'

      return state.updatingAutoFinalizing || orderIsFinalizing
    }
  }
}
